import { buildURL, fetchRequest } from 'Utils/api-fetch-request';

const PLAYLISTS_URL = '/api/playlists/';
const PLAYLIST_ITEMS_URL = '/api/playlist-items/';

export interface Playlist {
    id: number;
    slug: string;
    title: string;
    description?: string;
    OR?: boolean;
}

export interface PlaylistsResponse {
    count: number;
    results: Playlist[];
}

export interface CreatePlaylistParams {
    title: string;
    description?: string;
}

export async function createPlaylist(params: CreatePlaylistParams): Promise<Playlist> {
    return fetchRequest(PLAYLISTS_URL, {
        method: 'POST',
        body: JSON.stringify(params),
    });
}

export interface PlaylistItem {
    id: number;
    order: number;
    /** Playlist slug. */
    playlist: string;
    /** Content-type model name (e.g. "video"). */
    content_type: string;
    content: { slug: string };
}

export interface AddPlaylistItemParams {
    playlistSlug: string;
    contentSlug: string;
}

export async function addPlaylistItem({ playlistSlug, contentSlug }: AddPlaylistItemParams): Promise<PlaylistItem> {
    return fetchRequest(PLAYLIST_ITEMS_URL, {
        method: 'POST',
        body: JSON.stringify({
            playlist: playlistSlug,
            content: contentSlug,
        }),
    });
}

export interface FetchUserPlaylistsParams {
    userProfileUuid: string;
    limit?: number;
    ordering?: string;
}

export async function fetchUserPlaylists({
    userProfileUuid,
    limit = 100,
    ordering = 'created',
}: FetchUserPlaylistsParams): Promise<PlaylistsResponse> {
    const url = buildURL(PLAYLISTS_URL, {
        author: userProfileUuid,
        limit,
        ordering,
    });
    return fetchRequest(url);
}
